module.exports = __webpack_public_path__ + "img/ganttchart.fe465244.png";